import {useCallback, useEffect, useState} from 'react'
import {getCustomSurvey} from './list/core/_requests'
import {createCustomSurveyApplication} from '../surveyapplication/list/core/_requests'
import 'survey-core/defaultV2.min.css'
import {StylesManager, Model} from 'survey-core'
import {Survey} from 'survey-react-ui'
import {useParams} from 'react-router-dom'
import 'survey-core/survey.i18n'

StylesManager.applyTheme('defaultV2')

const Preview = () => {
  const params = useParams()
  const [survey, setSurvey] = useState<any>('')
  const [isloading, setisloading] = useState(true)
  const [surveyid, setsurveyid] = useState(0)

  useEffect(() => {
    if (!params.Guid) {
      setisloading(false)
      return
    }

    getCustomSurvey(params.Guid)
      .then((res) => {
        const data = res?.data ?? res
        if (!data) {
          return
        }

        try {
          const surveyJson = data.surveyJson
          const parsedSurvey = typeof surveyJson === 'string' ? JSON.parse(surveyJson) : ''
          setSurvey(parsedSurvey)
          setsurveyid(Number(data.id || 0))
        } catch (error) {
          console.error('Survey JSON parse hatası:', error)
          setSurvey('')
        }
      })
      .finally(() => {
        setisloading(false)
      })
  }, [params.Guid])

  const alertResults = useCallback(
    (sender: any) => {
      if (!surveyid) {
        return
      }

      const results = JSON.stringify(sender.data)
      const payload = {id: 0, name: results, surveyId: surveyid}
      createCustomSurveyApplication(payload)
    },
    [surveyid]
  )

  let md = new Model(survey)
  md.focusFirstQuestionAutomatic = false
  md.locale = 'tr'
  md.onComplete.add(alertResults)

  return !isloading ? (
    <div style={{backgroundColor: '#f3f3f3', height: '100vh'}}>
      <Survey model={md} />
    </div>
  ) : (
    <div style={{backgroundColor: '#f3f3f3', height: '100vh'}}></div>
  )
}

export {Preview}
